/**
 * The active organisation (Organisations, dev only).
 *
 * Set by OrgProvider (src/lib/useOrgs.tsx) whenever the active organisation
 * changes; NEVER set while FEATURE_ORGANISATIONS is off, so production keeps
 * today's behaviour exactly (courses by their creator, org_id left null).
 * A plain module value rather than a hook because db.ts is not React: course
 * creation and the course list read it at call time.
 */
let activeOrg: string | null = null
let owned = false
let personal: string | null = null

/**
 * `isOwner`: the person owns this organisation — their pre-organisation courses
 * and media show in it. `userId`: their own id, which is where that older
 * content lives (org_id = user id, from before organisations).
 */
export function setActiveOrgId(id: string | null, isOwner = false, userId: string | null = null): void {
  activeOrg = id && id.startsWith('org_') ? id : null
  owned = !!activeOrg && isOwner
  personal = owned ? userId : null
}

/**
 * Whose media a picker lists for this tenant: the organisation, plus — in the
 * organisation you own — your own older uploads (Step 2, 30 Sep 2026). Any
 * other tenant (a personal one, production) is just itself.
 */
export function mediaOwnerIds(tenantId: string): string[] {
  return tenantId === activeOrg && owned && personal ? [tenantId, personal] : [tenantId]
}

/**
 * True when the active organisation is the one this person owns. Until adoption
 * moves existing content in (ORG_ADOPTION, off until release), their courses made
 * before organisations existed (org_id null) are listed here — the organisation
 * adoption would put them in. Nothing is moved; it only changes what is listed.
 */
export function activeOrgIsOwned(): boolean {
  return owned
}

/** The organisation new courses belong to and the course list is scoped to, or null (personal, as today). */
export function activeOrgId(): string | null {
  return activeOrg
}
